import React, { createContext, useEffect, useState } from 'react';
import { Spin } from "antd";

import { getLoginUser } from '../services/auth.service';
import { useLocation } from 'react-router-dom';

export const GlobalContext = createContext(null);

const GlobalContextProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [breadCrumb, setBreadCrumb] = useState([]);
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getLoginUser().then((response) => {
      setUser(response.data);
    })
    .catch((error) => {
      if (pathname === '/under-construction') {
        return;
      }
      window.location.href = '/under-construction';
      console.log(error);
    }).finally(() => {
      setLoading(false);
    });
  }, []);
  return (
      <GlobalContext.Provider value={{user, setUser, breadCrumb, setBreadCrumb, loading, setLoading}}>
        {loading && (
            <div className="spinner-overlay">
              <Spin size="large" />
            </div>
        )}
          {children}
      </GlobalContext.Provider>
);
};

export default GlobalContextProvider;
